import { createSlice } from "@reduxjs/toolkit";
import { AccountType } from "../../home/types";

export interface CounterState {
  account: { label: string; value: AccountType } | null;
  portFolio: any;
}

const initialState: CounterState = {
  account: null,
  portFolio: null,
};

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setAccount: (state, action) => {
      state.account = action.payload;
      return state;
    },
    setPortFolio: (state, action) => {
      console.log("action.payload", action.payload);
      state.portFolio = action.payload;
      return state;
    },
  },
});

export const { setAccount, setPortFolio } = accountSlice.actions;

export default accountSlice.reducer;

export const selectAccount = (state: { account: CounterState }) =>
  state.account.account;

export const selectPortFolio = (state: { account: CounterState }) =>
  state.account.portFolio;
